import React, { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { URL } from '../constants'
import { AuthContext } from '../store/auth-context'


const PrivateRoute = ({children}: any) => {

    const authCtx = useContext(AuthContext)
	const {pathname, search} = window.location

	return (
		authCtx.isLoggedIn ? children : <Navigate to={`${URL.signIn}${(!pathname || pathname !== '/') ? `?redirect_to=${pathname}${search}` : ''}`} />
	)
}

export default PrivateRoute
